import {
  SFCheckIcon,
  ACTION_BAR_ACTION_NAMES,
  ACTION_BAR_ACTION_TYPES,
  hasPermission,
} from "@sf-core";
import { Claims } from "../../constants/claims";

const getActionDefs = ({
  t,
  onSyncSkillsClick = () => {},
  disableSkillsSync = false,
  onCancelClick = () => {},
  onTenantHandlerClick = () => {},
  onDeleteClick = () => {},
  onRestoreClick = () => {},
  stateProp,
  idProp,
}) => [
  ...(idProp && hasPermission(Claims.AdminTenantsSyncSkills)
    ? [
      {
        name: "syncSkills",
        type: ACTION_BAR_ACTION_TYPES.BUTTON,
        onClick: onSyncSkillsClick,
        disabled: disableSkillsSync,
        buttonProps: {
          label: t("tenantsScreen.tenantsForm.syncSkills"),
          variant: "secondary",
          async: true,
        },
        confirmation: true,
        confirmationProps: {
          message: t("tenantsScreen.tenantsForm.confirmSyncSkills", {
            tenantName: stateProp.data.name,
          }),
        },
      },
    ]
    : []),
  {
    name: ACTION_BAR_ACTION_NAMES.CANCEL,
    type: ACTION_BAR_ACTION_TYPES.BUTTON,
    onClick: onCancelClick,
    buttonProps: {
      label: t("components.toolbar.templates.cancel"),
      variant: "secondary",
    },
  },
  {
    name: idProp ? ACTION_BAR_ACTION_NAMES.EDIT : ACTION_BAR_ACTION_NAMES.ADD,
    type: ACTION_BAR_ACTION_TYPES.BUTTON,
    onClick: onTenantHandlerClick,
    buttonProps: {
      label: idProp
        ? t("tenantsScreen.tenantsForm.saveButton")
        : t("tenantsScreen.tenantsForm.addButton"),
      variant: "primary",
      icon: <SFCheckIcon size="small" />,
      async: true,
    },
    confirmation: true,
    confirmationProps: {
      header: idProp  ? t("tenantsScreen.tenantsForm.confirmUpdateHeader")
        : t("tenantsScreen.tenantsForm.confirmAddHeader"),
      message: idProp  ? t("tenantsScreen.tenantsForm.confirmUpdate")
        : t("tenantsScreen.tenantsForm.confirmAdd"),
    }
  },
  ...(idProp
    ? [
      {
        name: ACTION_BAR_ACTION_NAMES.DELETE,
        type: ACTION_BAR_ACTION_TYPES.BUTTON,
        onClick: onDeleteClick,
        buttonProps: {
          label: t("tenantsScreen.tenantsForm.delete"),
          variant: "primary",
          disabled: !stateProp.data.isActive,
          async: true,
        },
        confirmation: true,
        confirmationProps: {
          header: t("tenantsScreen.tenantsForm.confirmDeleteHeader"),
          message: t("tenantsScreen.tenantsForm.confirmDelete", {
            name: stateProp.data.name,
          }),
        }
      },
      ...(!stateProp.data.isActive ? [{
        name: "restore",
        type: ACTION_BAR_ACTION_TYPES.BUTTON,
        onClick: onRestoreClick,
        buttonProps: {
          label: t("tenantsScreen.tenantsForm.restore"),
          variant: "secondary",
          disabled: stateProp.data.isActive,
          async: true,
        },
        confirmation: true,
        confirmationProps: {
          header: t("tenantsScreen.tenantsForm.confirmRestoreHeader"),
          message: t("tenantsScreen.tenantsForm.confirmRestore", {
            name: stateProp.data.name,
          }),
        }}]
        : [])
    ]
    : []),
];

export default getActionDefs;
